const creditorItems = [
    //{ name: "ENVIO DE HABILITAÇÕES E DIVERGÊNCIAS", route: "/envio-habilitacoes-divergencias" },
    { name: "Minha conta", route: "/minha-conta" },
    { name: "Resumo Geral", route: "/resumo-geral" },
    { name: "HABILITAÇÕES / DIVERGÊNCIAS", route: "/habilitacoes-divergencias" },
    { name: "CERTIDÕES DE CRÉDITO (CHC)", route: "/certidoes-credito" },
    { name: "DOCUMENTOS SOLICITADOS", route: "/documentos-solicitados" },
    { name: "MODELOS DE DOCUMENTOS", route: "/modelos-documentos" },
    // Credenciamentos e substabelecimentos ficam como sub-itens de Assembleia de Credores,
    // para o menu nao abrir com tantas opcoes de cara.
    {
        name: "ASSEMBLEIA DE CREDORES",
        children: [
            { name: "Assembleias", route: "/assembleia-credores" },
            { name: "Credenciamentos", route: "/credenciamentos" },
            { name: "Substabelecimentos", route: "/substabelecimentos" },
        ],
    },
    { name: "ADESÃO AO PLANO", route: "/adesao-plano" },
    { name: "CENTRAL DE DOCUMENTOS", route: "/central-documentos" },
    { name: "INFORMAÇÃO BANCÁRIA", route: "/informacao-bancaria" },
    { name: "Solicitação PPP", href: "https://docs.google.com/forms/d/e/1FAIpQLSeYjjO27FMiA8ckkblFFkB8r-Ix7i4hQGzutqc6Es-ytAAXDQ/viewform" },
];

// Credenciamentos, substabelecimentos e a pagina por caso ficam dentro de
// "Assembleia de Credores" (as rotas continuam existindo, so saem do menu).
const procuratorItems = [
    { name: "Minha conta", route: "/minha-conta" },
    { name: "Resumo Geral", route: "/resumo-geral" },
    { name: "CREDORES", route: "/procurador/credores" },
    { name: "HABILITAÇÕES / DIVERGÊNCIAS", route: "/habilitacoes-divergencias" },
    { name: "CERTIDÕES DE CRÉDITO (CHC)", route: "/certidoes-credito" },
    { name: "ASSEMBLEIA DE CREDORES", route: "/assembleia-credores" },
    { name: "ADESÃO AO PLANO", route: "/adesao-plano" },
    { name: "DOCUMENTOS SOLICITADOS", route: "/documentos-solicitados" },
    { name: "CENTRAL DE DOCUMENTOS", route: "/central-documentos" },
];

export default [...creditorItems];
export { creditorItems, procuratorItems };
